import BaseComponent from "@js/components/base_component.jsx";
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "@js/components/eui/modal/index.js";
import clickWrap from "@js/helpers/click_wrap.js";

class EuiArchivedMessagesIndex extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
        q: {},
        show_search: false,
    };

    if ( props.q ) this.state.q = props.q;
  }

  render() {
    return <div>
        <div className="row m-b-lg">
            <div className="col-sm-8 text-left" style={{"verticalAlign": "middle"}}>
              {
                this._describeCurrentSearch()
              }
            </div>

            <div className="col-sm-4 text-right" style={{"verticalAlign": "middle"}}>
                <a className="btn btn-primary" onClick={ clickWrap(() => this.setState({ show_search: true })) }>
                    Search the message archive
                </a>
            </div>
        </div>

        {/* Index of archived messages */}

        <Panel heading="message_archive">
            {this.props.entities && this.props.entities.total > 0 ? (
                <div>
                    <ArchivedMessagesTable
                        archived_messages={this.props.entities.data}
                        library={this.props.library}
                    />
                    <Paginator entity={this.props.entities} />
                </div>
            ) : (
                <div>
                    <br />
                    <EmptyTableNotification
                        text={
                            I18n.t("empty_table." + (
                                (
                                    this.props.library.system_configuration.injected_message_archive ?
                                    ( Object.keys(this.state.q || {}).length > 0 ? "archived_messages_none_matched" : "archived_messages_none" ) :
                                    ( this.props.library.system_configuration.greenarrow_cloud_id ? "archived_messages_not_enabled_cloud" : "archived_messages_not_enabled" )
                                )
                            ))
                        }
                        color="gray"
                        icon="check-circle"
                        rawHtml={ true }
                        offerNew={ false }
                    />
                </div>
            )}
        </Panel>

        {/* Search modal */}

        {
          this.state.show_search && (
            <div>
                <form
                    method="GET"
                    action={ Routes.eui_archived_messages_path() }
                >

                    <Modal>
                        <ModalHeader onCancel={ clickWrap(() => this.setState({ show_search: false })) }>
                            Search Message Archive
                        </ModalHeader>
                        <ModalBody>
                            <InputField
                                object={ this.state.q }
                                type="query_archived_messages"
                                name="q[mailclass]"
                                field="mailclass"
                                editing={ true }
                            />
                            <InputField
                                object={ this.state.q }
                                type="query_archived_messages"
                                name="q[instanceid]"
                                field="instanceid"
                                editing={ true }
                            />
                            <InputField
                                object={ this.state.q }
                                type="query_archived_messages"
                                name="q[rfc5321_mailfrom]"
                                field="rfc5321_mailfrom"
                                editing={ true }
                            />
                            <InputField
                                object={ this.state.q }
                                type="query_archived_messages"
                                name="q[rfc5322_from]"
                                field="rfc5322_from"
                                editing={ true }
                            />
                            <InputField
                                object={ this.state.q }
                                type="query_archived_messages"
                                name="q[recipient]"
                                field="recipient"
                                editing={ true }
                                multiline={ true }
                            />
                        </ModalBody>
                        <ModalFooter>
                            <a href={ Routes.eui_archived_messages_path() } className="btn btn-default">Clear</a>
                            <button type="submit" className="btn btn-primary">Search</button>
                        </ModalFooter>
                    </Modal>

                </form>
            </div>
          )
        }
    </div>;
  }

  _describeCurrentSearch() {
    let parts = [];

    for ( const key in this.state.q ) {
      const type = I18n.t(`simple_form.labels.query_archived_messages.${ key }`);
      const value = this.state.q[key];

      parts.push(`”${ value }” (${ type })`);
    }

    if ( parts.length === 0 ) return null;

    return I18n.t("phrases.showing_search_results_for_q_plain", {
      q: parts.join(", "),
    });
  }

}

class ArchivedMessagesTable extends BaseComponent {

    render() {
        return (
            <table className="table table-hover table-domains">
                <thead>{ this._headers() }</thead>
                <tbody>{ this.props.archived_messages.map(this._row) }</tbody>
            </table>
        );
    }

    _headers() {
        return <tr>
            <th style={{ "width": "150px" }}>{ I18n.t("headings.time_injected") }</th>
            <th style={{ "width": "13%" }}>{ I18n.t("headings.mail_class_or_category") }</th>
            <th style={{ "width": "13%" }}>{ I18n.t("headings.description") }</th>
            <th style={{ "width": "13%" }}>{ I18n.t("headings.rfc5321_mailfrom_domain") }</th>
            <th style={{ "width": "13%" }}>{ I18n.t("headings.rfc5322_from_domain") }</th>
            <th>{ I18n.t("headings.recipients") }</th>
            <th style={{ "width": "100px" }} className="index-buttons column-actions">&nbsp;</th>
        </tr>;
    }

    _row(msg) {
        return <tr key={ msg.seq }>
            <td>{ msg.time_injected_pretty }</td>
            <td>{ msg.send_category }</td>
            <td>{ msg.send_description }</td>
            <td>{ msg.rfc5321_mailfrom_domain }</td>
            <td>{ msg.rfc5322_from_domain }</td>
            <td>{ msg.recipients.map((r, ii) => (
                <React.Fragment key={ ii }>
                    { ii > 0 && <br/> }
                    { r }
                </React.Fragment>
            )) }</td>
            <td className="index-buttons" style={{ "textAlign": "right" }}>
                {
                    ( msg.has_headers || msg.has_body ) &&
                        <ButtonWithIcon
                            type="index"
                            icon="download"
                            href={ Routes.eui_archived_message_path({ id: msg.seq }, { time_injected: msg.time_injected_epoch, disposition: "download" }) }
                            tabIndex="-1"
                            download={ true }
                            size="small"
                        />
                }
                <ButtonView
                    href={ Routes.eui_archived_message_path({ id: msg.seq }, { time_injected: msg.time_injected_epoch }) }
                    size="small"
                    text={ false }
                />
            </td>
        </tr>;
    }

}

export default EuiArchivedMessagesIndex;
